import React from 'react';
import PropTypes from 'prop-types';
import {action} from 'mobx';
import {inject, observer} from 'mobx-react';
import {withRouter} from 'react-router';

import autobind from 'autobind-decorator';

import CheckoutNewPaypalForm from '../CheckoutPaymentDetails/CheckoutNewPaypalForm';

import {PAYMENT_TYPES} from '../../state/payments/billing';

import '../CheckoutPaymentDetails/checkout-payment-details.less';

import paypal from 'spa/images/icons/paypal-solo.svg';

@withRouter
@inject(({
  store: {
    billing,
  },
}) =>
  ({
    billing,
  }))
@observer
class PaypalOption extends React.Component {
  static propTypes = {
    canUsePaypal: PropTypes.bool,
    chargeCountry: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    onChangeToken: PropTypes.func.isRequired,
    paypalAccounts: PropTypes.array.isRequired,
    paymentInfo: PropTypes.shape({
      paymentOption: PropTypes.string,
      paymentToken: PropTypes.string,
    }).isRequired,
    setPaymentToken: PropTypes.func.isRequired,
  };

  static defaultProps = {
    canUsePaypal: false,
    disabled: false,
  };

  @autobind
  @action('onChangeToken - PaypalOption')
  onChangeToken(event) {
    const {
      onChangeToken,
    } = this.props;

    onChangeToken(event);
  }

  render() {
    const {
      onChangeToken,
      props,
    } = this;
    const {
      canUsePaypal,
      chargeCountry,
      disabled,
      paymentInfo,
      paypalAccounts,
    } = props;

    if (!canUsePaypal || paymentInfo.paymentOption !== PAYMENT_TYPES.PAYPAL) {
      return null;
    }

    return (
      <div className="checkout-payment-details__payment-methods">
        {paypalAccounts.map(paypalAccount => (
          <label className="checkout-payment-details__payment-method" key={paypalAccount.id}>
            <div className="checkout-payment-details__payment-method--cover" />
            <input
              type="radio"
              name="payment-token"
              value={paypalAccount.id}
              onChange={onChangeToken}
              checked={paymentInfo.paymentToken === paypalAccount.id}
              disabled={disabled}
            />
            <span className="checkout-payment-details__payment-method-icon">
              <img src={paypal} alt="" />
            </span>
            <span className="checkout-payment-details__payment-method-label">{paypalAccount.descriptor}</span>
          </label>
        ))}
        <CheckoutNewPaypalForm
          countryId={chargeCountry}
          paymentInfo={paymentInfo}
          isFirst={!paypalAccounts.length}
        />
      </div>
    );
  }
}

export default PaypalOption;



// WEBPACK FOOTER //
// ./spa/Components/AddPaymentMethod/PaypalOption.jsx